module.exports = __webpack_public_path__ + "media/images/dummy-content/iframe-adyen-00b0ef0e8f774ae1ed0aab99aaa90768.jpg";